/**
 * A dummy project id to use in events where you really should provide a project
 * id, but the database schema stupidly has the project id as an optional field
 */
export const DUMMY_PROJECT_ID = '7c4e69c5-f376-4646-8f3a-e992a763b14c'
